<template>
	<div class="container-fluid">
		<navigation-admin></navigation-admin>
		<div class="row row-fluid wrapper-flexbox">
			<sidebar-admin></sidebar-admin>
			<section class="col-sm-10 admin-background-shadow overflow">
				<div class="row">
					<div class="col-sm-2">
						<p class="admin-header">Newsletter</p>
					</div>
					<div class="col-sm-offset-8 col-sm-2">
						<button class="btn btn-black btn-lg">Exportar archivo</button>
					</div>
				</div>
				<div class="row row-fluid absolute">
					<div class="col-sm-12 table-responsive">
						<table-admin-newsletter :list="render_newsletters"></table-admin-newsletter>
						<div v-if="!render_newsletters.length">No hay usuarios suscritos.</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import navigationAdmin from '../../components/Admin/Admin-navigation.vue';
import sidebarAdmin from '../../components/Admin/Admin-sidebar.vue';
import tableAdminNewsletter from '../../components/Admin/Admin-table-newsletter.vue';

export default {
	vuex: {
		getters: {
			newsletters: state => state.newsletters
		}
	},

	comptuted: {
		render_newsletters() {
			return this.newsletters;
		}
	},

  components: {
    navigationAdmin,
    sidebarAdmin,
    tableAdminNewsletter,
  },
}
</script>


// WEBPACK FOOTER //
// Admin-newsletter.vue?60750ca2